import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import {
  FlowAdapter,
  type FlowAttributeReferenceType,
} from "@validereinc/domain";
import React from "react";

export const ProductCategoryDropdownInput = ({
  name = "product_category",
  label,
  ...props
}: Omit<
  EntityDropdownProps<FlowAttributeReferenceType[]>,
  "fetchEntityList"
>) => {
  return (
    <EntityDropdownInput
      fetchEntityList={FlowAdapter.productCategories.getList}
      label={label ?? "Product Category"}
      name={name}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
